import { render, staticRenderFns } from "./okao-menu.vue?vue&type=template&id=6e67ddb5&scoped=true&lang=pug&"
import script from "./okao-menu.vue?vue&type=script&lang=js&"
export * from "./okao-menu.vue?vue&type=script&lang=js&"
import style0 from "./okao-menu.vue?vue&type=style&index=0&id=6e67ddb5&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e67ddb5",
  null
  
)

export default component.exports